/**
 * 匿名访客 id(TAPD 1006913)
 *
 * 落地页没有登录态,PV/UV 就靠这个:localStorage 里存一个随机串,同一浏览器复用。
 * 只用于埋点去重算 UV,不关联任何真实身份;localStorage 不可用(隐身模式/被禁)时
 * 退化成一次性 id —— 那种情况下这次访问只算 PV,不影响页面功能。
 */
const KEY = 'video_share_visitor_id'

const randomId = () => `v_${Date.now().toString(36)}${Math.random().toString(36).slice(2, 10)}`

let memoryId = ''

export const getVisitorId = () => {
  if (memoryId) return memoryId
  try {
    const saved = window.localStorage.getItem(KEY)
    if (saved) {
      memoryId = saved
      return memoryId
    }
    memoryId = randomId()
    window.localStorage.setItem(KEY, memoryId)
    return memoryId
  } catch (e) {
    memoryId = randomId()
    return memoryId
  }
}



// WEBPACK FOOTER //
// ./src/modules/videoShare/visitorId.js